/**
 * Preview mode: an administrator walks the panel with the draft branding, dashboard and
 * pages applied. Remembered per tab (sessionStorage) and entered through ?preview=draft.
 * The API only honours it for administrators who manage the tenant, so a customer who turns
 * it on sees nothing different.
 */
const KEY = 'hearth.customisation.preview';

export function isPreviewMode(): boolean {
  try {
    return sessionStorage.getItem(KEY) === 'draft';
  } catch {
    return false;
  }
}

export function setPreviewMode(on: boolean): void {
  try {
    if (on) sessionStorage.setItem(KEY, 'draft');
    else sessionStorage.removeItem(KEY);
  } catch {
    // Private mode: preview just doesn't persist across reloads.
  }
}

/** `?preview=draft` on the URL turns preview on once, then is removed from the address bar. */
export function adoptPreviewFromUrl(): void {
  try {
    const url = new URL(window.location.href);
    const value = url.searchParams.get('preview');
    if (value === 'draft') setPreviewMode(true);
    else if (value === 'off') setPreviewMode(false);
    else return;
    url.searchParams.delete('preview');
    window.history.replaceState(window.history.state, '', url.toString());
  } catch {
    // Nothing to adopt.
  }
}
